import React, { useCallback } from 'react';
import { useSelector } from 'react-redux';
import { AvailableModals, closeModal } from '../modalSlice';
import { ReduxState, useAppDispatch } from '../../../store';
import { Modal } from 'antd';
import EditRedistribution from '../../CalculationDetail/Editation/EditRedistribution';
import { getTitleBasedOnModalData } from '../../CalculationDetail/Editation/editRedistributionLib';

const modalId = AvailableModals.EDIT_REDISTRIBUTION;

const EditRedistributionModal: React.FC = () => {
  const dispatch = useAppDispatch();

  const open = useSelector((state: ReduxState) => state.modal.openedModal === modalId);
  const modalData = useSelector((state: ReduxState) => state.modal.modalData[modalId]);

  const handleClose = useCallback(() => {
    dispatch(closeModal());
  }, [dispatch]);

  const titleBasedOnData = getTitleBasedOnModalData(modalData);

  if (!open) return null;
  if (!modalData) return null;
  return (
    <Modal
      title={titleBasedOnData}
      centered
      open={true}
      width="80%"
      onCancel={handleClose}
      footer={null}
    >
      <EditRedistribution {...modalData} />
    </Modal>
  );
};

export default EditRedistributionModal;
